var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.auth.user)?_c('dashboard'):_c('Login')
}
var staticRenderFns = []

export { render, staticRenderFns }